// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AFVseJm6yyDBYIaG10EVy .MuiFormControlLabel-label {\n    font-size: 1em;\n}\n\n._6eF3FCUwDOKyo-fPjW_q6 {\n    max-height: calc(100vh - 295px);\n    margin-bottom: 20px;\n    overflow: auto;\n    /* fixes material checkbox 'splash' from getting cut off */\n    padding-left: 20px;\n    margin-left: -20px;\n}\n\n._3CXx1-5seSUDNiXcqj8D9O {\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n._6ug8EwILuAA2m-Hmwit_p {\n    padding-left: 8px;\n}", ""]);
// Exports
exports.locals = {
	"exportFormsModal": "AFVseJm6yyDBYIaG10EVy",
	"fields": "_6eF3FCUwDOKyo-fPjW_q6",
	"buttonContainer": "_3CXx1-5seSUDNiXcqj8D9O",
	"indentedCheckbox": "_6ug8EwILuAA2m-Hmwit_p"
};
module.exports = exports;
